import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep3_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F54.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame54() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);

    useEffect(() => {

    }, [])

    
        return (
            <div className="F54_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F54_entryBox">
                    <div className="F54_paragraph">
                        {language === 'english' ?
                            <p className="F54_paragraphEnglish">Today, during lunch break, Saira overheard senior schoolgirls discussing that it would be embarrassing to use the sanitary station as such things should always be kept secret and it’s of no use. Saira knows they are wrong but afraid to confront girls who are far more senior than her</p>
                            :
                            <p className="F54_paragraphUrdu"> آج سائرا نے سکول میں کچھ لڑکیوں کو یہ کہتے ہوئے سنا کہ سینیٹری سٹیشن کو استعمال کرنا شرم کی بات ہو گی کیونکہ ایسی چیزوں کو راز میں ہی رکھنا چاہیئے سائرا یہ جانتی ہے کہ یہ بات کتنی غلط ہے لیکن اپنے سے بڑی عمر کی لڑکیوں سےبات کرنے سے گھبرا رہی ہے۔</p>
                        }
                    </div>

                    <div className="F54_timeline">
                        <div className='F54_timelineBar'>
                            <div className='F54_timelineFill'></div>
                            <span className='F54_timelineText'>4/14</span>
                        </div>
                    </div>

                    <div className="F54_nextFrames">
                        <div className="F54_nextFrame1"></div>
                        <div className="F54_nextFrame2"></div>
                        <div className="F54_nextFrame3"></div>
                    </div>

                    <div className='F54_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep3_lastVisitFrame(4)) }} className='F54_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    
}

export default Frame54;